import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "sw-lightsaber-luke-ep6-v3-stunt",
  name: `Lightsaber\n"Luke v3" Stunt Saber Ep6`,
  nameFormatted: {
    primary: "Lightsaber",
    secondary: '"Luke v3" Stunt Saber Ep6',
  },
  origin: "Star Wars: Episode VI - Return of the Jedi",

  category: replicaCategories.starWars,

  versions: [Version1],
};

export default data;
